/** @file VIEWPORT_COLORS: the viewport palette (mockup 2026-10-21): grid, axes, gizmo handles, background. */

/** Hex colours; the gizmo uses the axis colours by handle index (X, Y, Z) and `hover` for the hovered handle; bones are `boneWire` wireframes. */
export const VIEWPORT_COLORS = {
  background: '#1b2620', gridMinor: '#2a4530', gridMajor: '#2f4a33', axisX: '#e06c6c', axisY: '#7bd88f', axisZ: '#6ca8e0',
  hover: '#f2b544', centre: '#d8dee9', joint: '#d8dee9', jointSelected: '#f2b544', bone: '#8fa3b8', boneWire: '#5fe3ff',
} as const;
